module.exports = __webpack_public_path__ + "static/media/government.717efb08.svg";